// SmartURL.js
const SmartURL = (src) => {
	const isLocal = process.env.REACT_APP_ENV === "local";
	return isLocal ? src : `https://xiosky.com/delmedia${src}`;
};

export default SmartURL;
